// $(document).ready(function () {
//   function selectedVariant(param, value) {
//     var url = new URL(window.location.href);

//     url.searchParams.set(param, value);

//     window.history.replaceState({}, "", url);
//   }

//   function updateSelection() {
//     var selectedValues = "";

//     $('.product-details__purchase-items input[type="radio"]:checked').each(
//       function () {
//         selectedValues += (selectedValues ? " / " : "") + $.trim($(this).val());
//       },
//     );

//     $(".select__variant option").each(function () {
//       if ($.trim($(this).text()) == selectedValues) {
//         var $option = $(this);

//         $option.prop("selected", true);

//         var variantId = $option.val();

//         var price = $option.data("price");

//         var comparePrice = $option.data("compare-price");

//         var isAvailable = $option.data("available");

//         $("#variant-id").val(variantId);

//         // ---- Price update ----

//         $(".single-product__price span").text(price);

//         var $del = $(".single-product__price del");

//         if (comparePrice && comparePrice !== "") {
//           if ($del.length) {
//             $del.text(comparePrice).show();
//           } else {
//             $(".single-product__price span").after(
//               "<del>" + comparePrice + "</del>",
//             );
//           }
//         } else {
//           $del.hide();
//         }

//         // ---- Sticky Cart variant & price update ----

//         // Sticky Cart variant ID update
//         $("#sticky-variant-id").val(variantId);

//         // Sticky Cart price update
//         $(".recommended-bundle__price span").text(price);

//         // Sticky Cart compare price update
//         var $stickyDel = $(".recommended-bundle__price del");

//         if (comparePrice && comparePrice !== "") {
//           if ($stickyDel.length) {
//             $stickyDel.text(comparePrice).show();
//           } else {
//             $(".recommended-bundle__price span").after(
//               "<del>" + comparePrice + "</del>",
//             );
//           }
//         } else {
//           $stickyDel.hide();
//         }

//         // ---- Add to cart button state ----

//         var $addBtn = $("#addToCart");

//         if (
//           isAvailable == false ||
//           isAvailable == "False" ||
//           isAvailable == "false"
//         ) {
//           $addBtn.addClass("is-disabled").text("SOLD OUT");
//         } else {
//           $addBtn.removeClass("is-disabled");
//         }

//         selectedVariant("variant", variantId);

//         return false;
//       }
//     });
//   }

//   $('.product-details__purchase-items input[type="radio"]').change(function () {
//     updateSelection();
//   });

//   updateSelection();

//   $(document)
//     .off("click.addToCart", "#addToCart")
//     .on("click.addToCart", "#addToCart", function (e) {
//       e.preventDefault();

//       var $btn = $(this);

//       if ($btn.hasClass("is-disabled")) return;

//       $btn.closest(".single-product__addtocart").addClass("is-loading");

//       $.ajax({
//         type: "POST",

//         url: "/cart/add.js",

//         data: { id: $("#variant-id").val(), quantity: 1 },

//         dataType: "json",

//         success: function () {
//           $("body").addClass("cart-drawer-show");

//           sectionRedering();
//         },

//         error: function (xhr) {
//           console.error("Add to cart failed:", xhr.responseJSON);
//         },

//         complete: function () {
//           $btn.closest(".single-product__addtocart").removeClass("is-loading");
//         },
//       });
//     });
// });



// $(document).ready(function () {
//   // Store original button HTML once (icon + text) so we can restore it later
//   var $addBtn = $("#addToCart");
//   var originalBtnHtml = $addBtn.html();

//   function selectedVariant(param, value) {
//     var url = new URL(window.location.href);
//     url.searchParams.set(param, value);
//     window.history.replaceState({}, "", url);
//   }

//   function updateSelection() {
//     var selectedValues = "";

//     $('.product-details__purchase-items input[type="radio"]:checked').each(
//       function () {
//         selectedValues += (selectedValues ? " / " : "") + $.trim($(this).val());
//       },
//     );

//     $(".select__variant option").each(function () {
//       if ($.trim($(this).text()) == selectedValues) {
//         var $option = $(this);
//         $option.prop("selected", true);

//         var variantId = $option.val();
//         var price = $option.data("price");
//         var comparePrice = $option.data("compare-price");
//         var isAvailable = $option.data("available");

//         $("#variant-id").val(variantId);

//         // ---- Price update ----
//         $(".single-product__price span").text(price);
//         var $del = $(".single-product__price del");
//         if (comparePrice && comparePrice !== "") {
//           if ($del.length) {
//             $del.text(comparePrice).show();
//           } else {
//             $(".single-product__price span").after("<del>" + comparePrice + "</del>");
//           }
//         } else {
//           $del.hide();
//         }

//         // ---- Sticky Cart variant & price update ----
//         $("#sticky-variant-id").val(variantId);
//         $(".recommended-bundle__price span").text(price);
//         var $stickyDel = $(".recommended-bundle__price del");
//         if (comparePrice && comparePrice !== "") {
//           if ($stickyDel.length) {
//             $stickyDel.text(comparePrice).show();
//           } else {
//             $(".recommended-bundle__price span").after("<del>" + comparePrice + "</del>");
//           }
//         } else {
//           $stickyDel.hide();
//         }

//         // ---- Add to cart button state ----
//         var $btn = $("#addToCart");

//         if (
//           isAvailable == false ||
//           isAvailable == "False" ||
//           isAvailable == "false"
//         ) {
//           $btn.addClass("is-disabled").text("SOLD OUT");
//         } else {
//           $btn.removeClass("is-disabled").html(originalBtnHtml);
//         }

//         selectedVariant("variant", variantId);
//         return false;
//       }
//     });
//   }

//   $('.product-details__purchase-items input[type="radio"]').change(function () {
//     updateSelection();
//   });

//   updateSelection();

//   $(document)
//     .off("click.addToCart", "#addToCart")
//     .on("click.addToCart", "#addToCart", function (e) {
//       e.preventDefault();
//       var $btn = $(this);
//       if ($btn.hasClass("is-disabled")) return;

//       $btn.closest(".single-product__addtocart").addClass("is-loading");

//       $.ajax({
//         type: "POST",
//         url: "/cart/add.js",
//         data: { id: $("#variant-id").val(), quantity: 1 },
//         dataType: "json",
//         success: function () {
//           $("body").addClass("cart-drawer-show");
//           sectionRedering();
//         },
//         error: function (xhr) {
//           console.error("Add to cart failed:", xhr.responseJSON);
//         },
//         complete: function () {
//           $btn.closest(".single-product__addtocart").removeClass("is-loading");
//         },
//       });
//     });
// });

$(document).ready(function () {
  // Store original button HTML once (icon + text) so we can restore it later
  var $addBtn = $("#addToCart");
  var originalBtnHtml = $addBtn.html();

  var $stickyBtn = $("#stickyAddToCart");
  var originalStickyBtnHtml = $stickyBtn.html();

  var $stickyMobiBtn = $(".sticky-add-to-cart");
  var originalStickyMobiBtnHtml = $stickyMobiBtn.html();

  function selectedVariant(param, value) {
    var url = new URL(window.location.href);
    url.searchParams.set(param, value);
    window.history.replaceState({}, "", url);
  }

  function updateSelection() {
    var selectedValues = "";

    $('.product-details__purchase-items input[type="radio"]:checked').each(
      function () {
        selectedValues += (selectedValues ? " / " : "") + $.trim($(this).val());
      },
    );

    $(".select__variant option").each(function () {
      if ($.trim($(this).text()) == selectedValues) {
        var $option = $(this);
        $option.prop("selected", true);

        var variantId = $option.val();
        var price = $option.data("price");
        var comparePrice = $option.data("compare-price");
        var isAvailable = $option.data("available");

        $("#variant-id").val(variantId);

        // ---- Price update ----
        $(".single-product__price span").text(price);
        var $del = $(".single-product__price del");
        if (comparePrice && comparePrice !== "") {
          if ($del.length) {
            $del.text(comparePrice).show();
          } else {
            $(".single-product__price span").after("<del>" + comparePrice + "</del>");
          }
        } else {
          $del.hide();
        }

        // ---- Sticky Cart variant & price update ----
        $("#sticky-variant-id").val(variantId);
        $(".recommended-bundle__price span").text(price);
        var $stickyDel = $(".recommended-bundle__price del");
        if (comparePrice && comparePrice !== "") {
          if ($stickyDel.length) {
            $stickyDel.text(comparePrice).show();
          } else {
            $(".recommended-bundle__price span").after("<del>" + comparePrice + "</del>");
          }
        } else {
          $stickyDel.hide();
        }

        // ---- Add to cart button state ----
        var $btn = $("#addToCart");
        var $sBtn = $("#stickyAddToCart");
        var $sMobiBtn = $(".sticky-add-to-cart");

        if (
          isAvailable == false ||
          isAvailable == "False" ||
          isAvailable == "false"
        ) {
          $btn.addClass("is-disabled").text("SOLD OUT");
          $sBtn.addClass("is-disabled").text("SOLD OUT");
          $sMobiBtn.addClass("is-disabled").text("SOLD OUT");
        } else {
          $btn.removeClass("is-disabled").html(originalBtnHtml);
          $sBtn.removeClass("is-disabled").html(originalStickyBtnHtml);
          $sMobiBtn.removeClass("is-disabled").html(originalStickyMobiBtnHtml);
        }

        selectedVariant("variant", variantId);
        return false;
      }
    });
  }

  $('.product-details__purchase-items input[type="radio"]').change(function () {
    updateSelection();
  });

  updateSelection();

  $(document)
    .off("click.addToCart", "#addToCart, #stickyAddToCart, .sticky-add-to-cart")
    .on("click.addToCart", "#addToCart, #stickyAddToCart, .sticky-add-to-cart", function (e) {
      e.preventDefault();
      var $btn = $(this);
      if ($btn.hasClass("is-disabled")) return;

      $btn.closest(".single-product__addtocart").addClass("is-loading");

      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { id: $("#variant-id").val(), quantity: 1 },
        dataType: "json",
        success: function () {
          $("body").addClass("cart-drawer-show");
          sectionRedering();
        },
        error: function (xhr) {
          console.error("Add to cart failed:", xhr.responseJSON);
        },
        complete: function () {
          $btn.closest(".single-product__addtocart").removeClass("is-loading");
        },
      });
    });
});